export default "__VITE_PUBLIC_ASSET__8445a669__"